import { render, staticRenderFns } from "./ConfettiTwo.vue?vue&type=template&id=19704edc&scoped=true&lang=pug&"
import script from "./ConfettiTwo.vue?vue&type=script&lang=js&"
export * from "./ConfettiTwo.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiTwo.vue?vue&type=style&index=0&id=19704edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19704edc",
  null
  
)

export default component.exports